function createTimeKey(key) {
  return key;
}

function createDataKey(key) {
  return `${key}_data`;
}

function createTimeValue(key, freshness) {
  return `${key}|${new Date().getTime() + freshness}`;
}

function extend(...args) {
  return Object.assign({}, ...args);
}

function hasLocalStorage() {
  try {
    localStorage.setItem("__x", "x");
    localStorage.removeItem("__x");
    return true;
  } catch (e) {
    return false;
  }
}

function expire(key) {
  if (hasLocalStorage()) {
    localStorage.removeItem(createTimeKey(key));
    localStorage.removeItem(createDataKey(key));
  }
  return null;
}

function get(opts) {
  const options = extend({ key: "", identifier: "" }, opts);
  let timeData;
  let timeParts = [];
  if (hasLocalStorage() && options.key !== "") {
    timeData = window.localStorage.getItem(createTimeKey(options.key));
    if (timeData !== null) {
      timeParts = timeData.split("|");
      if (timeParts.length === 2) {
        if (timeParts[0] === options.identifier) {
          if (new Date().getTime() <= parseInt(timeParts[1], 10)) {
            return window.localStorage.getItem(createDataKey(options.key));
          }
          expire(options.key);
        }
      }
    }
  }
  return null;
}

function set(options) {
  options = extend(
    { key: "", identifier: "", data: "", freshness: 600000 },
    options
  );
  if (hasLocalStorage()) {
    if (options.key !== "") {
      window.localStorage.setItem(
        createTimeKey(options.key),
        createTimeValue(options.identifier, options.freshness)
      );
      window.localStorage.setItem(createDataKey(options.key), options.data);
    }
  }
  return options.data;
}

export { get as getLocalStorage, set as setLocalStorage };
